import {DefaultUrlSerializer, UrlTree} from '@angular/router';
import {Injectable} from '@angular/core';

/**
 * 'CleanUrlSerializer' class definition.
 */
@Injectable()
export class CleanUrlSerializer extends DefaultUrlSerializer {
	/**
	 * Clean url.
	 * @param {string} oldUrl
	 * @returns {void}
	 */
	static cleanUrl(oldUrl: string) {
		return oldUrl.replace(/\(.*\)/g, ''); // for example to delete parenthesis
	}

	/**
	 * Serialize.
	 * @param {UrlTree} tree
	 * @returns {string}
	 */
	public serialize(tree: UrlTree): string {
		return CleanUrlSerializer.cleanUrl(super.serialize(tree));
	}
}
